module.exports = __webpack_public_path__ + "img/icon_file_x.e49b75b.png";